import React from 'react'
import classes from './SaleItemAttributes.module.sass'
import { ItemAttribute } from '../../types/interfaces'
import { shortenText } from '../../utils/functions/shortenText'
import { useSaleItemAttributes } from './useSaleItemAttributes'

type Props = {
  view?: boolean
  attributes?: ItemAttribute[]
}

export const SaleItemAttributes = ({ attributes, view }: Props) => {
  const { sortRequiredFirst, formatAttributeValue } = useSaleItemAttributes()

  if (!attributes || attributes.length === 0) {
    return <div className={view ? classes.containerView : classes.container} />
  }

  const sorted = [...attributes].sort(sortRequiredFirst)
  const display = view ? sorted : sorted.slice(0, 2)
  const remaining = view ? 0 : Math.max(0, attributes.length - 2)

  return (
    <div className={view ? classes.containerView : classes.container}>
      <div className={classes.topContainer}>
        {view && <div className={classes.more}>Атрибуты</div>}
        {!view && (
          <div className={`${classes.title} ${classes.more}`}>
            Атрибуты{remaining > 0 && `, и еще ${remaining}`}
          </div>
        )}
        <div className={classes.row}>
          {display.map((el) => (
            <div key={el.id} className={view ? classes.attributeView : classes.attribute}>
              <div className={classes.label}>{el.name}</div>
              <div className={classes.value}>
                {view ? formatAttributeValue(el) : shortenText(formatAttributeValue(el), 10)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
